import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "😵", key: "forgetSpecs" },
  { emoji: "🧩", key: "scatteredInfo" },
  { emoji: "⌛", key: "takesTooLong" },
  { emoji: "❌", key: "mistakes" },
]

export default function CarsBiggestPainPage() {
  return (
    <RadioCardListPage translationKey="carsBiggestPain" options={OPTIONS} />
  )
}
